import FlagSpriteSheet from '@img/icons/flags/rectangle/sprite.svg?url';
import React, { FunctionComponent } from 'react';
import { CultureFlagStyles } from './CultureFlag.styles';

export interface CultureFlagProps {
  cultureCode: string;
  width?: number;
  height?: number;
  includeBorder?: boolean;
}

const CultureFlag: FunctionComponent<CultureFlagProps> = ({
  cultureCode,
  width = 32,
  height = 32,
  includeBorder = false,
}) => {
  const getFlagSpriteId = (cultureCode: string): string => {
    switch (cultureCode) {
      case 'nl-BE':
        return 'fr-BE';
      default:
        return cultureCode;
    }
  };

  return (
    <CultureFlagStyles.Image w={width} h={height} includeBorder={includeBorder}>
      <use href={`${FlagSpriteSheet}#${getFlagSpriteId(cultureCode)}`} />
    </CultureFlagStyles.Image>
  );
};

export default CultureFlag;
